import { render, staticRenderFns } from "./ExternalSearch.vue?vue&type=template&id=06f8312e&scoped=true&"
import script from "./ExternalSearch.vue?vue&type=script&lang=js&"
export * from "./ExternalSearch.vue?vue&type=script&lang=js&"
import style0 from "./ExternalSearch.vue?vue&type=style&index=0&id=06f8312e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f8312e",
  null
  
)

export default component.exports